import React from "react";
import Button from "@material-ui/core/Button";
import { postData } from "../../../api/componentAPIs";
import "./style.scss";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./MapPopupStyles.js";
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import MESSAGES  from "../../../appMessages";
import {trackEvent} from "../../common/AppInsightsEventTracking";
class AnchorPointPopupInfo extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            droppingAnchorPointInProgress: false
        }
        this.isComponentMounted = false;
    }

    componentDidMount(){
      this.isComponentMounted = true;
    }

    componentWillUnmount(){
      this.isComponentMounted = false;
    }

    dropAnchorPoint = () => {
        const { data, userProfile } = this.props;
        this.setState({
            droppingAnchorPointInProgress: true
        });
        postData("UpdateRouteAnchorPoint", {
          scenarioId: this.props.scenarioID,
          routeNames: [data.routeName],
          anchorPointName: null
        }).then(
          response => {
            if (response && Math.trunc(response.status/100) === 2) {
                this.props.showNotification(MESSAGES.ANCHORPOINT.DROP_SUCCESS, "success");
                this.props.refreshData();
            } else {
              this.props.showNotification(MESSAGES.ANCHORPOINT.DROP_FAILURE, "error");
            }
            if(this.isComponentMounted){
              this.setState({
                droppingAnchorPointInProgress: false
              })
            }
          },
          error => {
            this.props.showNotification(MESSAGES.ANCHORPOINT.DROP_FAILURE, "error");
            if(this.isComponentMounted){
              this.setState({
                droppingAnchorPointInProgress: false
              })
            }
          }
        );

        trackEvent("AnchorPointDropped", userProfile, {route:data.routeName});
    }

    render(){
        const infoData = this.props.data;
        const { classes, theme } = this.props;
        return (
            <Paper className={`${classes.anchorPointRoot} popupBGColor`}>
            <Table className={classes.table} padding="none">
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.headHeight}>
                  <TableCell className={classes.tableHeadCell}>
                    <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={infoData.consigneeName}>
                     <div className={classes.routeNameInfo}>
                        AP: {infoData.consigneeName}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell className={`${classes.tableHeadCell} ${classes.rightCell}`}>
                      <span className={classes.startTime}>
                        Empty Time: {infoData.anchorPointEmptyTime}
                      </span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              { this.props.isAnchorPointModulePopup && (
                <TableRow className={classes.anchorPointTableRowRoot}>
                  <TableCell className={`${classes.labelCell} tableCellName`}>Route</TableCell>
                  <TableCell className={`${classes.dataCell} tableCellValue`}>
                    <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={infoData.routeAssigned || ""}>
                      <span> {infoData.routeAssigned}</span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              )}
              { !this.props.isAnchorPointModulePopup && (
                <TableRow className={classes.anchorPointTableRowRoot}>
                  <TableCell className={`${classes.labelCell} tableCellName`}>ETA</TableCell>
                  <TableCell className={`${classes.dataCell} tableCellValue`}>
                    {infoData.eta}
                  </TableCell>
                </TableRow>
              )}
              { !this.props.isAnchorPointModulePopup ? (
                <TableRow className={classes.anchorPointTableRowRoot}>
                  <TableCell className={`${classes.anchorPointBtnCell} ${this.props.disableDrop ? classes.disabled : ""}`} colSpan={2}>
                    <Button
                    className={classes.anchorPointBtn}
                    classes={{disabled: classes.disabledBtn}}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={this.dropAnchorPoint}
                    disabled={this.props.disableDrop}
                    >
                        {this.state.droppingAnchorPointInProgress ? <CircularProgress  size={16} classes={{root: classes.progress}} />: "Drop Anchor Point"}
                    </Button>
                  </TableCell>
                </TableRow>
              ): null
              }
              </TableBody>
            </Table>
          </Paper>
        )
    }
}
export default withStyles(styles)(AnchorPointPopupInfo);